import React, { Fragment, useEffect, useState } from 'react'
import PiesAge from './PiesAge';


const AgeResults = ({ results }) => {

    const [oneTwelve, setOneTwelve] = useState(0)
    const [oneTen, setOneTen] = useState(0)
    const [oneEight, setOneEight] = useState(0)
    const [oneSix, setOneSix] = useState(0)
    const [oneFour, setOneFour] = useState(0)


    const [fiveTwelve, setFiveTwelve] = useState(0)
    const [fiveTen, setFiveTen] = useState(0)
    const [fiveEight, setFiveEight] = useState(0)
    const [fiveSix, setFiveSix] = useState(0)
    const [fiveFour, setFiveFour] = useState(0)

    useEffect(() => {
        results.forEach((result, i) => {
            if (result.sequenceContext === "Etage R+1") {
                result.results.forEach((res, i) => {
                    if (res.resource.attributes[0].quantity === "8") {
                        setOneTwelve(res.personalData.nbHoursHome)
                    } else if (res.resource.attributes[0].quantity === "10") {
                        setOneTen(res.personalData.nbHoursHome)
                    } else if (res.resource.attributes[0].quantity === "12.5") {
                        setOneEight(res.personalData.nbHoursHome)
                    } else if (res.resource.attributes[0].quantity === "16.5") {
                        setOneSix(res.personalData.nbHoursHome)
                    } else if (res.resource.attributes[0].quantity === "25") {
                        setOneFour(res.personalData.nbHoursHome)
                    }
                })
            } else if (result.sequenceContext === "Etage R+5") {
                result.results.forEach((res, i) => {
                    if (res.resource.attributes[0].quantity === "8.5") {
                        setFiveTwelve(res.personalData.nbHoursHome)
                    } else if (res.resource.attributes[0].quantity === "10") {
                        setFiveTen(res.personalData.nbHoursHome)
                    } else if (res.resource.attributes[0].quantity === "12.5") {
                        setFiveEight(res.personalData.nbHoursHome)
                    } else if (res.resource.attributes[0].quantity === "16.5") {
                        setFiveSix(res.personalData.nbHoursHome)
                    } else if (res.resource.attributes[0].quantity === "25") {
                        setFiveFour(res.personalData.nbHoursHome)
                    }
                })
            }
        }
        )

    }, [results])

    const pieR1R12 = [
        { name: '< 2 heures', value: oneTwelve.l2 / oneTwelve.total * 100 },
        { name: '2 à 4 heures', value: oneTwelve.f2t4 / oneTwelve.total * 100 },
        { name: '4 à 6 heures', value: oneTwelve.f4t6 / oneTwelve.total * 100 },
        { name: '6 à 8 heures', value: oneTwelve.f6t8 / oneTwelve.total * 100 },
        { name: '> 8 heures', value: oneTwelve.m8 / oneTwelve.total * 100 },
    ]

    const pieR5R12 = [
        { name: '< 2 heures', value: fiveTwelve.l2 / fiveTwelve.total * 100 },
        { name: '2 à 4 heures', value: fiveTwelve.f2t4 / fiveTwelve.total * 100 },
        { name: '4 à 6 heures', value: fiveTwelve.f4t6 / fiveTwelve.total * 100 },
        { name: '6 à 8 heures', value: fiveTwelve.f6t8 / fiveTwelve.total * 100 },
        { name: '> 8 heures', value: fiveTwelve.m8 / fiveTwelve.total * 100 },
    ]

    const pieR1R10 = [
        { name: '< 2 heures', value: oneTen.l2 / oneTen.total * 100 },
        { name: '2 à 4 heures', value: oneTen.f2t4 / oneTen.total * 100 },
        { name: '4 à 6 heures', value: oneTen.f4t6 / oneTen.total * 100 },
        { name: '6 à 8 heures', value: oneTen.f6t8 / oneTen.total * 100 },
        { name: '> 8 heures', value: oneTen.m8 / oneTen.total * 100 },
    ]

    const pieR5R10 = [
        { name: '< 2 heures', value: fiveTen.l2 / fiveTen.total * 100 },
        { name: '2 à 4 heures', value: fiveTen.f2t4 / fiveTen.total * 100 },
        { name: '4 à 6 heures', value: fiveTen.f4t6 / fiveTen.total * 100 },
        { name: '6 à 8 heures', value: fiveTen.f6t8 / fiveTen.total * 100 },
        { name: '> 8 heures', value: fiveTen.m8 / fiveTen.total * 100 },
    ]

    const pieR1R8 = [
        { name: '< 2 heures', value: oneEight.l2 / oneEight.total * 100 },
        { name: '2 à 4 heures', value: oneEight.f2t4 / oneEight.total * 100 },
        { name: '4 à 6 heures', value: oneEight.f4t6 / oneEight.total * 100 },
        { name: '6 à 8 heures', value: oneEight.f6t8 / oneEight.total * 100 },
        { name: '> 8 heures', value: oneEight.m8 / oneEight.total * 100 },
    ]

    const pieR5R8 = [
        { name: '< 2 heures', value: fiveEight.l2 / fiveEight.total * 100 },
        { name: '2 à 4 heures', value: fiveEight.f2t4 / fiveEight.total * 100 },
        { name: '4 à 6 heures', value: fiveEight.f4t6 / fiveEight.total * 100 },
        { name: '6 à 8 heures', value: fiveEight.f6t8 / fiveEight.total * 100 },
        { name: '> 8 heures', value: fiveEight.m8 / fiveEight.total * 100 },
    ]

    const pieR1R6 = [
        { name: '< 2 heures', value: oneSix.l2 / oneSix.total * 100 },
        { name: '2 à 4 heures', value: oneSix.f2t4 / oneSix.total * 100 },
        { name: '4 à 6 heures', value: oneSix.f4t6 / oneSix.total * 100 },
        { name: '6 à 8 heures', value: oneSix.f6t8 / oneSix.total * 100 },
        { name: '> 8 heures', value: oneSix.m8 / oneSix.total * 100 },
    ]

    const pieR5R6 = [
        { name: '< 2 heures', value: fiveSix.l2 / fiveSix.total * 100 },
        { name: '2 à 4 heures', value: fiveSix.f2t4 / fiveSix.total * 100 },
        { name: '4 à 6 heures', value: fiveSix.f4t6 / fiveSix.total * 100 },
        { name: '6 à 8 heures', value: fiveSix.f6t8 / fiveSix.total * 100 },
        { name: '> 8 heures', value: fiveSix.m8 / fiveSix.total * 100 },
    ]

    const pieR1R4 = [
        { name: '< 2 heures', value: oneFour.l2 / oneFour.total * 100 },
        { name: '2 à 4 heures', value: oneFour.f2t4 / oneFour.total * 100 },
        { name: '4 à 6 heures', value: oneFour.f4t6 / oneFour.total * 100 },
        { name: '6 à 8 heures', value: oneFour.f6t8 / oneFour.total * 100 },
        { name: '> 8 heures', value: oneFour.m8 / oneFour.total * 100 },
    ]

    const pieR5R4 = [
        { name: '< 2 heures', value: fiveFour.l2 / fiveFour.total * 100 },
        { name: '2 à 4 heures', value: fiveFour.f2t4 / fiveFour.total * 100 },
        { name: '4 à 6 heures', value: fiveFour.f4t6 / fiveFour.total * 100 },
        { name: '6 à 8 heures', value: fiveFour.f6t8 / fiveFour.total * 100 },
        { name: '> 8 heures', value: fiveFour.m8 / fiveFour.total * 100 },
    ]



    return (
        <Fragment>
            <PiesAge
                context="Votes des participants selon le nombre d'heures passées par jour à leur domicile"
                contextDetail="Hors période Covid"
                pieR1R12={pieR1R12}
                pieR5R12={pieR5R12}
                pieR1R10={pieR1R10}
                pieR5R10={pieR5R10}
                pieR1R8={pieR1R8}
                pieR5R8={pieR5R8}
                pieR1R6={pieR1R6}
                pieR5R6={pieR5R6}
                pieR1R4={pieR1R4}
                pieR5R4={pieR5R4}
            />

        </Fragment>

    )
}

export default AgeResults
